var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2320 4619 c-1686 -204 -2428 -2249 -1264 -3483 1002 -1061 2764 -775 3384 549 682 1456 -526 3127 -2120 2934z m750 -207 c1286 -372 1820 -1848 1068 -2955 -591 -870 -1856 -1081 -2709 -452 -1279 942 -936 2933 584 3394 324 99 743 104 1057 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683 3054 c-23 -26 -43 -62 -43 -80 0 -48 72 -43 107 8 20 29 46 39 86 35 84 -10 83 -66 -1 -141 -79 -70 -93 -116 -34 -116 55 0 202 151 202 207 0 124 -224 185 -317 87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3173 3059 c-62 -49 -71 -119 -16 -119 20 0 53 18 74 41 48 53 137 46 145 -13 4 -28 -17 -59 -65 -96 -78 -59 -93 -112 -32 -112 59 0 201 148 201 209 0 123 -193 179 -307 90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744 2655 c10 -71 116 -77 116 -6 0 44 -9 51 -61 51 -53 0 -61 -7 -55 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3240 2650 c0 -40 10 -50 50 -50 40 0 50 10 50 50 0 40 -10 50 -50 50 -40 0 -50 -10 -50 -50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload3);
export default __webpack_public_path__ + "static/media/picsvg_download(3).1ad890af273777b377ed5e53d8079452.svg";
export { ForwardRef as ReactComponent };